(function () {
    document.querySelectorAll('.alpha-compare__slider').forEach(function (slider) {
        var sectionId = slider.id.replace('alpha-compare-slider-', '');
        var line = document.getElementById('alpha-compare-line-' + sectionId);
        var handle = document.getElementById('alpha-compare-handle-' + sectionId);
        var afterImg = document.getElementById('alpha-compare-after-' + sectionId);
        var dragging = false;

        function update(clientX) {
            var rect = slider.getBoundingClientRect();
            var pct = ((clientX - rect.left) / rect.width) * 100;
            pct = Math.max(2, Math.min(98, pct));

            line.style.left = pct + '%';
            handle.style.left = pct + '%';
            afterImg.style.clipPath = 'inset(0 0 0 ' + pct + '%)';
        }

        slider.addEventListener('pointerdown', function (e) {
            dragging = true;
            slider.setPointerCapture(e.pointerId);
            update(e.clientX);
        });

        slider.addEventListener('pointermove', function (e) {
            if (!dragging) return;
            update(e.clientX);
        });

        slider.addEventListener('pointerup', function () {
            dragging = false;
        });

        slider.addEventListener('pointercancel', function () {
            dragging = false;
        });
    });
})();